// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.m_AAQDqsiKrCgs3pyg2i {
  display: flex;
  flex-direction: column;
}

.m_AAQDqsiKrCgs3pyg2i p {
  font-size: 20px;
}

.m_AAQDqsiKrCgs3pyg2i hr {
  width: 100%;
}

.z6Vkp3pK0rlXQxrHDNhY {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  color: color-text;
}


.fKQayElp6wo_Wl3GWUhU {
  font-weight: bold;
}`, "",{"version":3,"sources":["webpack://./src/components/PaymentDetails/PaymentDetails.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,iBAAiB;AACnB;;;AAGA;EACE,iBAAiB;AACnB","sourcesContent":[".recap {\n  display: flex;\n  flex-direction: column;\n}\n\n.recap p {\n  font-size: 20px;\n}\n\n.recap hr {\n  width: 100%;\n}\n\n.recapSection {\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  color: color-text;\n}\n\n\n.bold {\n  font-weight: bold;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"recap": `m_AAQDqsiKrCgs3pyg2i`,
	"recapSection": `z6Vkp3pK0rlXQxrHDNhY`,
	"bold": `fKQayElp6wo_Wl3GWUhU`
};
export default ___CSS_LOADER_EXPORT___;
